(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["cf-wishlist-styles"] && !Shopify.designMode) return;
  try {
    (() => {
    function refreshVariant(scope, selector, id, productId) {
      if (!scope || !id) return;
      for (const placeholder of scope.querySelectorAll(selector)) {
        if (productId && placeholder.dataset.gwProductId !== String(productId)) continue;
        if (placeholder.dataset.gwVariantId === String(id)) continue;
        const replacement = placeholder.cloneNode(false);
        replacement.removeAttribute('data-gw-moi-id');
        replacement.setAttribute('style', 'display:block');
        replacement.dataset.gwVariantId = String(id);
        placeholder.replaceWith(replacement);
      }
    }
    document.addEventListener('variant:update', (event) => {
      if (!(event.target instanceof Element)) return;
      const detail = event.detail;
      refreshVariant(
        event.target.closest('.shopify-section, dialog'),
        '.cf-wishlist-product',
        detail?.resource?.id,
        detail?.data?.productId
      );
    });
    document.addEventListener('click', (event) => {
      if (!(event.target instanceof Element) || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
      const swatch = event.target.closest('cf-colour-card [data-colour-variant]');
      if (!swatch) return;
      const picker = swatch.closest('cf-colour-card');
      queueMicrotask(() => {
        refreshVariant(picker?.closest('product-card'), '.cf-wishlist-card', picker?.dataset.selectedVariant, picker?.dataset.productId);
      });
    }, { capture: true });
    function customizeWishlist() {
      const styles = document.getElementById('CfWishlistAppStyles');
      if (!styles || !window.gw?.registerWidgetCustomization) return;
      window.gw.registerWidgetCustomization(
        (config) => config.widgetName.includes('Wishlist'),
        () => ({ styleElement: styles })
      );
    }
    if (window.gw?.sdk) customizeWishlist();
    else document.addEventListener('gwSdkReady', customizeWishlist, { once: true });
  })();
  } catch(e) { console.error(e); }
})();

})();
